import React from 'react';
import { Cell, HtmlTable } from '../../../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { IconButton } from '../../../../../../../../CommonComponents/OPL/IconButton/IconButton';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import type { EssentialTeamRoleDTO } from '../../../../../../../types/goalsDTO';

interface Props {
  roles: EssentialTeamRoleDTO[];
  isPrint: boolean;
  onEditRole: (role: EssentialTeamRoleDTO) => void;
  onDeleteRole: (role: EssentialTeamRoleDTO) => void;
}

export const EssentialRolesTable = ({
  roles,
  isPrint,
  onEditRole,
  onDeleteRole,
}: Props) => (
  <HtmlTable mt="8" columnSpacing="small" maxWidth="100%">
    <table>
      <caption>
        <Text fontWeight={600} textAlign="left">
          Essential Roles
        </Text>
      </caption>
      <thead>
        <tr>
          <th>
            <Text variant="smallCaps" textAlign="left">
              Name
            </Text>
          </th>
          <th>
            <Text variant="smallCaps" textAlign="left">
              Role
            </Text>
          </th>
          <th>
            <Text variant="smallCaps" textAlign="left">
              Description
            </Text>
          </th>
          <th>
            <Text variant="smallCaps" textAlign="left">
              Email
            </Text>
          </th>
          <th>
            <Text variant="smallCaps" textAlign="left">
              Phone
            </Text>
          </th>
          {!isPrint && <th aria-label="Actions" />}
        </tr>
      </thead>
      <tbody>
        {roles.length === 0 && (
          <tr>
            <Cell colSpan={isPrint ? 5 : 6}>
              <Text fontSize="small" color="neutral.500">
                No essential roles have been added to the estate plan yet.
              </Text>
            </Cell>
          </tr>
        )}
        {roles.map(row => (
          <tr key={row.Id}>
            <Cell>{row.Name || '—'}</Cell>
            <Cell>{row.RoleName || '—'}</Cell>
            <Cell css="max-width: 360px;">
              <Text fontSize="small">{row.Description || '—'}</Text>
            </Cell>
            <Cell>{row.Email || '—'}</Cell>
            <Cell>{row.PhoneNumber || '—'}</Cell>
            {!isPrint && (
              <Cell css="white-space: nowrap;">
                <IconButton
                  variant="subtleInactive"
                  icon="far fa-pencil"
                  onClick={() => onEditRole(row)}
                  aria-label="Edit essential role"
                />
                <IconButton
                  variant="subtleInactive"
                  icon="far fa-minus-circle"
                  onClick={() => onDeleteRole(row)}
                  ml="8"
                  aria-label="Delete essential role"
                />
              </Cell>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  </HtmlTable>
);
